import React from 'react';
import { connect } from 'react-redux';
import { RichText } from 'prismic-reactjs';
import styles from './kolofon.module.scss';
import Icon from '../Icon';
import Button from '../Button';
import Modal from '../Modal';
import { makeContentRenderable } from '../helper';

class KolofonContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      toggle: !prevState.toggle,
    }));
  }

  render() {
    const { kolofon } = this.props;
    const modalClass = [styles.modal];
    if (this.state.toggle) {
      modalClass.push(styles.showModal);
    }
    let renderableKolofon = makeContentRenderable(kolofon);
    return [
      <Button onClick={this.toggle} key={'kolo_btn'}>
        <Icon icon="info" />
      </Button>,
      <Modal show={this.state.toggle} onCancel={this.toggle} key="kolo_modal">
        <div className={modalClass.join(' ')}>
          {RichText.render(renderableKolofon)}
        </div>
      </Modal>
    ];
  }
}

const mapStateToProps = (state) => {
  return { }
}

const mapDispatchToProps = (dispatch) => {
  return { }
}

const Kolofon = connect(
  mapStateToProps,
  mapDispatchToProps,
)(KolofonContainer);

export default Kolofon;

/*
data {
  kolofon {
    type
    text
    url
    spans {
      start
      end
      type
    }
  }
}
*/



// WEBPACK FOOTER //
// ./src/components/Kolofon/index.jsx